/** @jsx jsx */

import { capitalize } from 'lodash';

import { jsx } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import {
  Alert,
  AlertDescription,
  ButtonGroup,
  Margin,
} from '@zapier/design-system';

import LinkButton from 'app/common/components/LinkButton';
import {
  GET_HELP_CTA,
  GET_HELP_PATH,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { getAppUrl } from 'app/developer-v3/utils';

type Props = {
  appId: string;
  requestedVersion?: string;
};

const VersionNotFoundPage = ({ appId, requestedVersion }: Props) => {
  const versionsUrl = `${getAppUrl(appId)}/versions`;
  const errorTitle = requestedVersion
    ? `App version ${requestedVersion} doesn't seem to exist.`
    : "This app version doesn't seem to exist.";

  return (
    <Margin margin="40px">
      <Alert status="error" title={errorTitle}>
        <AlertDescription>
          It may have been deleted or never published. Please check the link or
          contact support if you think this is a mistake.
        </AlertDescription>
      </Alert>
      <Margin margin="40px 0px 0px">
        <ButtonGroup columnSize="minmax(100px, max-content)" justify="center">
          {versionsUrl && (
            <LinkButton
              aria-label="Click to follow a link to the app versions page"
              variant="primary"
              href={versionsUrl}
            >
              All App Versions
            </LinkButton>
          )}
          <LinkButton
            aria-label="Click to follow a link to the help page"
            variant="tertiary"
            href={`${ZAPIER_APP_BASE_URL}${GET_HELP_PATH}`}
            iconPosition="start"
            target="_blank"
          >
            <Icon name="commentBlankFill" />
            {capitalize(GET_HELP_CTA)}
          </LinkButton>
        </ButtonGroup>
      </Margin>
    </Margin>
  );
};

export default VersionNotFoundPage;
